
// TODO: fermer les autres accordion quand on en ouvre un
// TODO: désactiver les élements lorsqu'on clique sur d'autres
// TODO: dupliquer le contenu de l'élement ouvert par défaut dans la case bleu

let accordionArray = document.querySelectorAll('.accordion');

accordionArray.forEach(function(item){

    let btns = item.querySelectorAll(":scope > .accordion-button");
    
    btns.forEach(function(item) {

        item.addEventListener('click', function(){
    
            let ariaControls = this.getAttribute('aria-controls');
            let ariaExpanded = this.getAttribute('aria-expanded');
            let content = document.getElementById(ariaControls);
            let parent = item.closest('.accordion');
            let children = parent.children;
            console.log(children);
        
            if(content.classList.contains('accordion-open')){
                content.classList.remove('accordion-open');
                content.style.maxHeight = "0px";
            }
            else {
                content.classList.add('accordion-open');
                content.style.maxHeight = content.scrollHeight + "px";
                
                //FOR JOBS: empty blue div + duplication of item to move on this div
                document.querySelectorAll('.jobs__detail__text')[0].innerHTML = "";
                var itemToClone = content.querySelector('.accordion-content');
                var clone = itemToClone.cloneNode(true);
                document.querySelectorAll('.jobs__detail__text')[0].appendChild(clone);
            }

            this.classList.toggle('collapsed');
            
            if(ariaExpanded == "true") {
                this.setAttribute('aria-expanded','false');
            }
            else {
                this.setAttribute('aria-expanded','true');
            }
        });

    });

});


